import { Page } from "./page";
import { CheckInSummary, CheckInSummaryDto } from "./checkInSummary";
import { PageResponse } from "./response";

export class CheckInsList {
  checkIns: CheckInSummary[];
  page: Page;

  constructor(data: PageResponse<CheckInSummaryDto>) {
    this.checkIns = data.data.map((d) => new CheckInSummary(d));
    this.page = data.page!;
  }
}
